import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageModule } from 'primeng/message';
import { CookieComponent } from './pages/cookie/cookie.component';
import { FatalExceptionComponent } from './pages/fatal-exception/fatal-exception.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { TermsComponent } from './pages/terms/terms.component';
import { UnauthorisedComponent } from './pages/unauthorised/unauthorised.component';
import { ForbiddenPage } from './pages/forbidden/forbidden.page';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { SessionFromEmailComponent } from './pages/session-from-email/session-from-email.component';

@NgModule({
  declarations: [
      CookieComponent,
      FatalExceptionComponent,
      PageNotFoundComponent,
      TermsComponent,
      UnauthorisedComponent,
      ForbiddenPage,
      SessionFromEmailComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    MessageModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    TextareaModule,
    ToastModule,
    CardModule
  ],
  providers: [],
  exports: [
    MessageModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule {}
